"use client";
const BRANDS = ["Universal", "Sony Music", "Warner", "Spotify", "Apple Music", "Tidal", "Ableton", "Splice", "Moog", "Roland"];

export function Marquee() {
  const items = [...BRANDS, ...BRANDS, ...BRANDS];
  return (
    <section className="relative py-16 border-y border-border overflow-hidden">
      <div className="absolute left-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-r from-background to-transparent" />
      <div className="absolute right-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-l from-background to-transparent" />
      <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground px-12 mb-8">
        ✦ Trusted output for —
      </div>
      <div className="marquee-track flex gap-16 whitespace-nowrap">
        {items.map((b, i) => (
          <span key={i} className="font-display text-7xl md:text-9xl text-outline uppercase tracking-tight">
            {b} <span className="text-[oklch(0.94_0.27_128)]">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
